
<section class="choosePlan">
    <div class="container pricing-container">
        <div class="row">
            <div class="col-12">
                <div class="sectionHeader text-center">
                    <h1>AI英文校正ツールTrinkaの料金プラン</h1>
                </div>
            </div>
            <div class="col-12">
                <div class="pricingTabs">
                    <ul class="nav nav-pills nav-justified">
                        <li class="nav-item">
                            <a class="nav-link active" [class.active]="activeTab === 'individuals'" data-toggle="pill" href="#Individuals" (click)="activeTab='individuals'; setTab('individuals')">
                                <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 9.5C10.933 9.5 12.5 7.933 12.5 6C12.5 4.067 10.933 2.5 9 2.5C7.067 2.5 5.5 4.067 5.5 6C5.5 7.933 7.067 9.5 9 9.5Z" stroke="#4f4f4f" stroke-width="1.5"/>
                                    <path d="M2.5 15.5C2.5 12.5 5.5 10 9 10C12.5 10 15.5 12.5 15.5 15.5" stroke="#4f4f4f" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                                <div class="content">
                                    <h3>個人</h3>
                                </div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'enterprise'" data-toggle="pill" href="#Enterprise" (click)="activeTab='enterprise'; setTab('enterprise')">
                                <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_1259_170)">
                                    <path d="M9.75 8.25H13.35C14.1901 8.25 14.6101 8.25 14.931 8.41349C15.2132 8.5573 15.4427 8.78677 15.5865 9.06901C15.75 9.38988 15.75 9.80992 15.75 10.65V15.75M9.75 15.75V4.65C9.75 3.80992 9.75 3.38988 9.58651 3.06901C9.4427 2.78677 9.21323 2.5573 8.93099 2.41349C8.61012 2.25 8.19008 2.25 7.35 2.25H4.65C3.80992 2.25 3.38988 2.25 3.06901 2.41349C2.78677 2.5573 2.5573 2.78677 2.41349 3.06901C2.25 3.38988 2.25 3.80992 2.25 4.65V15.75M16.5 15.75H1.5M4.875 5.25H7.125M4.875 8.25H7.125M4.875 11.25H7.125" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_1259_170">
                                    <rect width="18" height="18" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                                <div class="content">
                                    <h3>エンタープライズ</h3>
                                </div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'institution'" data-toggle="pill" href="#Institution" (click)="activeTab='institution'; setTab('institution')">
                                <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_1259_176)">
                                    <path d="M2.25 15.7499H15.75M4.5 13.4999V7.49992M7.5 13.4999V7.49992M10.5 13.4999V7.49992M13.5 13.4999V7.49992M15 5.24992L9.318 1.69867C9.20264 1.62657 9.14495 1.59052 9.08309 1.57646C9.0284 1.56403 8.9716 1.56403 8.91691 1.57646C8.85505 1.59052 8.79736 1.62657 8.682 1.69867L3 5.24992H15Z" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_1259_176">
                                    <rect width="18" height="18" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                                <div class="content">
                                    <h3>大学・機関</h3>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tab-content w-100">
                <!-- Individuals Tabs -->
                <div class="tab-pane" [class.active]="activeTab === 'individuals'" id="Individuals">
                    <p class="pc-note">
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 5.25L5.41667 9.75L14.75 0.75" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        個人のお客様でご利用いただける4つのプラン。無料プランからでも、いつでもアップグレードいただけます。
                    </p>
                    <div class="trinkaToggleButton mt-1">
                        <div class="trinkaToogleWrapper d-flex justify-content-center align-items-center">
                            <p>月払い</p>
                            <label class="switch" style="margin:0 8px;">
                                <input type="checkbox" checked [(ngModel)]="isYearlyChecked">
                                <span class="slider-rd round"></span>
                            </label>
                            <p>年払い <span class="discountBadge">（67%オトクに）</span></p>
                        </div>
                    </div>
                    <div class="pricingContainer">
                        <!-- Basic -->
                        <div class="pricingCardBox basicPlan">
                            <div class="pricingCardHeader basicCardHeader">
                                <div class="cardTop">
                                    <h2>ベーシック</h2>
                                    <p>
                                        有料プランのご契約前に、<br/>
                                        Trinkaの機能を無料でお試しいただけます
                                    </p>
                                    <div class="amount" *ngIf="decodedData && decodedData.length > 0">
                                        <div class="amt_div">
                                            <b>{{decodedData[0].currency}}</b><h3>0</h3><span>／月</span>
                                        </div>
                                    </div>
                                    <div class="infoContainer">
                                        <p> 無料（クレジットカード登録不要）</p>
                                    </div>
                                </div>
                                <div class="cardButton">
                                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">無料で始める</a>
                                </div>
                            </div>
                            <div class="pricingCardBody">
                                <div class="cardSection">
                                    <div class="innerCard">
                                        <ul class="v2-checklister">
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        英文チェック・パラフレーズ
                                                        <small class="d-block">(月あたり5000単語まで)</small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ファイル自動校正<br/>
                                                        (1か月4件まで)<br/>
                                                        <small class="custom-tooltip text-left">
                                                            (Trinkaトークン使用)
                                                            <div class="custom-tooltip-content">
                                                                Trinkaの特定の機能をお使いいただく上で、それぞれ決められたトークン数が必要になります。 
                                                            </div>
                                                        </small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        AIアシスト機能とAI Apps<br/>(1か月5件まで)
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ライトモード（文法チェック）+<br/>
                                                        標準モード（パラフレーザー）
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        標準的なデータプライバシー
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        盗用・剽窃スコア<br/>(1か月1件まで)
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Premium -->
                        <div class="pricingCardBox premiumPlan">
                            <div class="pricingCardHeader premiumCardHeader">
                                <div class="cardTop">
                                    <h2>
                                        <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.3951 4.75268L14.4351 0.283879C14.3174 0.106806 14.1186 0 13.9059 0H3.59473C3.38189 0 3.1832 0.10681 3.06552 0.283879L0.105557 4.75268C-0.0523844 4.99014 -0.0313026 5.30351 0.156838 5.51712L8.27278 14.7836C8.39265 14.9213 8.56664 15 8.74992 15C8.9332 15 9.10717 14.9213 9.22766 14.7829L17.3436 5.51649C17.5311 5.3035 17.5522 4.99014 17.3951 4.75268ZM5.16536 5.73417L7.13239 11.5597L2.02998 5.73417H5.16536ZM10.2134 1.26537L11.064 4.46946H6.43436L7.28494 1.26537H10.2134ZM10.9949 5.73417L8.74962 12.3856L6.50432 5.73417H10.9949ZM12.334 5.73417H15.4695L10.367 11.5597L12.334 5.73417ZM15.6866 4.46878H12.377L11.5265 1.26469H13.5646L15.6866 4.46878ZM3.93531 1.26533H5.97341L5.12284 4.46942H1.81255L3.93531 1.26533Z" fill="#7A28A0"/>
                                        </svg>
                                        プレミアム
                                    </h2>
                                    <p>
                                        使用頻度の高いお客様向け<br/>
                                        無制限の英文チェック・パラフレーズ
                                    </p>
                                    <div class="amount" *ngIf="decodedData && decodedData.length > 0">
                                        <div id="yearly" class="amt_div" *ngIf="isYearlyChecked; else monthlyContent">
                                            <b>{{decodedData[0].currency}}</b>
                                            <h3>
                                                {{ Math.floor(decodedData[2].final_amount / 12) }}<small>.{{ ((decodedData[2].final_amount / 12) % 1).toFixed(2).split('.')[1] }}</small>
                                            </h3>
                                            <span><del>{{decodedData[0].currency}} {{decodedData[2].amount| number:'1.0-0'}}</del> <small>／月</small></span>
                                        </div>
                                    </div>
                                    <ng-template #monthlyContent>
                                        <div id="monthly" class="amt_div">
                                            <b>{{decodedData[0].currency}}</b><h3>{{decodedData[2].amount| number:'1.0-0'}}</h3><span>／月</span>
                                            <!-- <b>$</b><h3>20</h3><span>per month</span> -->
                                        </div>
                                    </ng-template>
                                    <div class="infoContainer" *ngIf="decodedData && decodedData.length > 0">
                                        <p *ngIf="isYearlyChecked">年払い年額 {{decodedData[0].currency}}{{decodedData[2].final_amount| number:'1.0-0'}} </p>
                                        <p *ngIf="!isYearlyChecked">請求済み {{decodedData[0].currency}}{{decodedData[2].amount| number:'1.0-0'}} 毎月</p>
                                    </div>
                                    
                                </div>
                                <div class="cardButton premiumButton">
                                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">プレミアムに登録</a>
                                </div>
                            </div>
                            <div class="pricingCardBody">
                                <div class="cardSection">
                                    <div class="innerCard">
                                        <ul class="v2-checklister">
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ベーシックの全機能に加えて
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        無制限の英文チェック・パラフレーズ
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ファイル自動校正<br/>
                                                        (1か月10件まで)<br/>
                                                        <small class="custom-tooltip text-left">
                                                            (Trinkaトークン使用)
                                                            <div class="custom-tooltip-content">
                                                                Trinkaの特定の機能をお使いいただく上で、それぞれ決められたトークン数が必要になります。 
                                                            </div>
                                                        </small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        AIアシスト機能とAI Apps<br/>(1か月25件まで)
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        一歩踏み込んだ添削モード
                                                        <small class="d-block">
                                                            パワーモード（文法チェック）+<br/>
                                                            標準、アカデミック、フォーマルなど<br/>
                                                            全モード（パラフレーザー）
                                                        </small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        スタイルガイドの選択
                                                        <small class="d-block">(AMA, APA, IEEE, ACS, AGU)</small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        Windowsデスクトップアプリ
                                                        <small class="d-block">MS Word/Outlook対応</small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        より強固なデータプライバシー
                                                        <small class="d-block">90日後のデータ消去 + AIによる学習なし</small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        盗用・剽窃スコア<br/>
                                                        (1か月2件まで)
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Premium Plus-->
                        <div class="pricingCardBox premiumPlus">
                            <div class="pricingCardHeader premiumPlusCardHeader">
                                <div class="cardTop">
                                    <h2>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20.898 9.43584L18.0227 5.26495C17.9083 5.09969 17.7152 5 17.5086 5H7.49202C7.28526 5 7.09225 5.09969 6.97793 5.26495L4.10254 9.43584C3.94911 9.65746 3.96959 9.94995 4.15236 10.1493L12.0364 18.798C12.1529 18.9265 12.3219 19 12.4999 19C12.678 19 12.847 18.9265 12.964 18.7974L20.8481 10.1487C21.0302 9.94994 21.0507 9.65746 20.898 9.43584ZM9.01778 10.3519L10.9286 15.789L5.97198 10.3519H9.01778ZM13.9216 6.18101L14.7479 9.1715H10.2505L11.0768 6.18101H13.9216ZM14.6808 10.3519L12.4996 16.5599L10.3185 10.3519H14.6808ZM15.9816 10.3519H19.0275L14.0708 15.789L15.9816 10.3519ZM19.2384 9.17086H16.0234L15.1971 6.18038H17.177L19.2384 9.17086ZM7.82287 6.18097H9.80274L8.97647 9.17146H5.76076L7.82287 6.18097Z" fill="#763393"/>
                                            <path d="M4.375 0.5625L5.08399 2.47851L7 3.1875L5.08399 3.89649L4.375 5.8125L3.66601 3.89649L1.75 3.1875L3.66601 2.47851L4.375 0.5625Z" fill="#763393"/>
                                            <path d="M1.75 4.9375L2.22266 6.21484L3.5 6.6875L2.22266 7.16016L1.75 8.4375L1.27734 7.16016L0 6.6875L1.27734 6.21484L1.75 4.9375Z" fill="#763393"/>
                                        </svg>
                                        プレミアムプラス
                                        <span class="bestValue">
                                            オススメ
                                        </span>
                                    </h2>
                                    <p>
                                        盗用・剽窃／AIコンテンツ／引用など<br/>
                                        各種チェックが必要な研究者向け
                                    </p>
                                    <div class="amount" *ngIf="decodedData && decodedData.length > 0">
                                        <div class="amt_div">
                                            <b>{{decodedData[0].currency}}</b>
                                            <h3>
                                                {{ Math.floor(decodedData[3].final_amount / 12) }}<small>.{{ ((decodedData[3].final_amount / 12) % 1).toFixed(2).split('.')[1] }}</small>
                                            </h3>
                                            <span><del>{{decodedData[0].currency}} {{ getOriginalPrice(decodedData[3].final_amount) / 12 | number:'1.0-0' }}</del> <small>／月</small></span>
                                            <!-- <h3>{{decodedData[0].amount | number:'1.2-2'}}</h3><span>per month</span> -->
                                            <!-- <b>$</b><h3>8.33</h3><span>per month</span> -->
                                        </div>
                                        <!-- <div class="amt_div" *ngIf="!isYearlyChecked">
                                            <b class="text-white">{{decodedData[0].currency}}</b>
                                            <h3 class="text-white">
                                                {{ decodedData[3].amount | number:'1.0-0' }}
                                                <small>{{ (decodedData[3].amount % 1).toFixed(2).substring(1) }}</small>
                                            </h3>
                                            <span>per month</span>
                                        </div> -->
                                    </div>
                                    <div class="infoContainer" *ngIf="decodedData && decodedData.length > 0">
                                        <p>年払い年額 {{decodedData[0].currency}}{{decodedData[3].final_amount | number:'1.0-0'}} </p>
                                        <!-- <span>Save upto {{decodedData[0].currency}}{{decodedData[0].currency=='$'?'36 ':'2880 '}}with every plagiarism check</span> -->
                                    </div>
                                </div>
                                <div class="cardButton premiumPlusButton">
                                    <a [attr.href]="isYearlyChecked ? 'https://cloud.trinka.ai/signup?_rg=JP' : null"
                                    target="_blank"
                                    [class.disabled-link]="!isYearlyChecked" target="_blank">プレミアムプラスに登録</a>
                                </div>
                                <p class="monthly-note" *ngIf="!isYearlyChecked">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.625 5.29167V3.66667C4.625 2.46958 5.59458 1.5 6.79167 1.5C7.98875 1.5 8.95833 2.46958 8.95833 3.66667V5.29167M6.79167 8C6.93533 8 7.0731 7.94293 7.17468 7.84135C7.27626 7.73977 7.33333 7.60199 7.33333 7.45833C7.33333 7.31467 7.27626 7.1769 7.17468 7.07532C7.0731 6.97374 6.93533 6.91667 6.79167 6.91667C6.64801 6.91667 6.51023 6.97374 6.40865 7.07532C6.30707 7.1769 6.25 7.31467 6.25 7.45833C6.25 7.60199 6.30707 7.73977 6.40865 7.84135C6.51023 7.94293 6.64801 8 6.79167 8ZM6.79167 8V9.625M3.86667 5.29167H9.71667C10.1933 5.29167 10.5833 5.68167 10.5833 6.15833V9.95C10.5833 10.665 9.99833 11.25 9.28333 11.25H4.3C3.585 11.25 3 10.665 3 9.95V6.15833C3 5.68167 3.39 5.29167 3.86667 5.29167Z" stroke="#FDAF2D" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    Annual billing only - switch to Yearly to unlock.
                                </p>
                            </div>
                            <div class="pricingCardBody">
                                <div class="cardSection">
                                    <div class="innerCard plagiarismCheck">
                                        <ul class="v2-checklister">
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        プレミアムプランの全機能に加えて
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        盗用・剽窃チェックライト
                                                        または<br/>
                                                        AIコンテンツチェック<br/>
                                                        (年あたり240ページまで)
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        引用フォーマット調整<br/>(年あたり600件)
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ファイル自動校正<br/>
                                                        (1か月20件まで)<br/>
                                                        <small class="custom-tooltip text-left">
                                                            (Trinkaトークン使用)
                                                            <div class="custom-tooltip-content">
                                                                Trinkaの特定の機能をお使いいただく上で、それぞれ決められたトークン数が必要になります。 
                                                            </div>
                                                        </small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        AIアシスト機能とAI Apps<br/>(1か月1,000件まで)
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ファイル翻訳
                                                        <small class="d-block">30以上の言語→英語/スペイン語</small>
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Enterprise-->
                        <div class="pricingCardBox cdpCardBox">
                            <div class="pricingCardHeader sensitiveHeader">
                                <div class="cardTop">
                                    <h2 class="text-white">
                                        <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.8452 4.66573C15.8452 4.2239 15.4869 3.86603 15.0451 3.86603C15.0228 3.86603 15.004 3.86603 14.9896 3.86603C12.9316 3.86603 11.1063 3.15961 9.59726 1.8609C9.25645 1.5676 8.74338 1.5676 8.40257 1.86091C6.89358 3.15957 5.06847 3.86603 3.01051 3.86603C2.99616 3.86603 2.97732 3.86603 2.95493 3.86603C2.51311 3.86603 2.15485 4.22388 2.15483 4.66569C2.15481 5.24485 2.15479 6.02029 2.15479 6.57512C2.15479 11.4468 5.06349 15.5402 9 16.7008C12.9365 15.5402 15.8452 11.4468 15.8452 6.57512C15.8452 6.0203 15.8452 5.24488 15.8452 4.66573Z" fill="#16A34A"/>
                                            <g clip-path="url(#clip0_568_1820)">
                                            <path d="M6.61369 12.9375H11.3864C11.5841 12.9375 11.7444 12.7772 11.7444 12.5795V8.52273C11.7444 8.32504 11.5841 8.16477 11.3864 8.16477H11.0285V7.09091C11.0285 5.97244 10.1185 5.0625 9.00006 5.0625C7.88159 5.0625 6.97165 5.97244 6.97165 7.09091V8.16477H6.61369C6.41601 8.16477 6.25574 8.32504 6.25574 8.52273V12.5795C6.25574 12.7772 6.41601 12.9375 6.61369 12.9375ZM9.35801 10.6701V11.1477C9.35801 11.3454 9.19774 11.5057 9.00006 11.5057C8.80237 11.5057 8.6421 11.3454 8.6421 11.1477V10.6701C8.4973 10.5612 8.40346 10.388 8.40346 10.1932C8.40346 9.86422 8.6711 9.59659 9.00006 9.59659C9.32902 9.59659 9.59665 9.86422 9.59665 10.1932C9.59665 10.388 9.50281 10.5612 9.35801 10.6701ZM7.68756 7.09091C7.68756 6.3672 8.27634 5.77841 9.00006 5.77841C9.72377 5.77841 10.3126 6.3672 10.3126 7.09091V8.16477H7.68756V7.09091Z" fill="white"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_568_1820">
                                            <rect width="7.875" height="7.875" fill="white" transform="translate(5.0625 5.0625)"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                        機密データ保護プラン
                                        <span class="bestValue">
                                            安心の高機密
                                        </span>
                                    </h2>
                                    <p>
                                        特に機密性の高いデータや情報を扱う<br/>
                                        専門家・研究者向け
                                    </p>
                                    <div class="amount" *ngIf="decodedData && decodedData.length > 0">
                                        <div class="amt_div text-white">
                                            <b class="text-white">$</b><h3 class="text-white">41<small>.67</small> </h3><span class="opacity-font">／月</span>
                                        </div>
                                        <!-- <div class="amt_div" *ngIf="!isYearlyChecked">
                                            <b>$</b><h3>41 <small>.67</small></h3><span>per month</span>
                                        </div> -->
                                    </div>
                                    <div class="infoContainer">
                                        <p><small>年払い年額 $500 </small></p>
                                    </div>
                                </div>
                                <div class="cardButton enterpriseButton">
                                    <button type="button" (click)="navigationService.goToEnterpriseForm()" [disabled]="!isYearlyChecked"
                                    [class.disabled-link]="!isYearlyChecked">機密データ保護プランに登録</button>
                                </div>
                                <p class="monthly-note" *ngIf="!isYearlyChecked">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.625 5.29167V3.66667C4.625 2.46958 5.59458 1.5 6.79167 1.5C7.98875 1.5 8.95833 2.46958 8.95833 3.66667V5.29167M6.79167 8C6.93533 8 7.0731 7.94293 7.17468 7.84135C7.27626 7.73977 7.33333 7.60199 7.33333 7.45833C7.33333 7.31467 7.27626 7.1769 7.17468 7.07532C7.0731 6.97374 6.93533 6.91667 6.79167 6.91667C6.64801 6.91667 6.51023 6.97374 6.40865 7.07532C6.30707 7.1769 6.25 7.31467 6.25 7.45833C6.25 7.60199 6.30707 7.73977 6.40865 7.84135C6.51023 7.94293 6.64801 8 6.79167 8ZM6.79167 8V9.625M3.86667 5.29167H9.71667C10.1933 5.29167 10.5833 5.68167 10.5833 6.15833V9.95C10.5833 10.665 9.99833 11.25 9.28333 11.25H4.3C3.585 11.25 3 10.665 3 9.95V6.15833C3 5.68167 3.39 5.29167 3.86667 5.29167Z" stroke="#FDAF2D" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    Annual billing only - switch to Yearly to unlock.
                                </p>
                            </div>
                            <div class="pricingCardBody">
                                <h4 class="mdTitle"></h4>
                                <div class="cardSection">
                                    <div class="innerCard enterpriseCard">
                                        <ul class="v2-checklister">
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        プレミアムプラスの全機能に加えて 
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        即時データ消去 
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        AIによるユーザーデータの学習なし 
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        オフライン文法チェッカーアプリ 
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        データ使用の透明性と管理の保証
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        盗用・剽窃チェックライト
                                                        または<br/>
                                                        AIコンテンツチェック
                                                        <small class="d-block">（年あたり1,000ページまで）</small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        盗用・剽窃チェックベーシック<br/>（1か月1件まで）
                                                        <small class="custom-tooltip text-left">
                                                            (Trinkaトークン使用)
                                                            <div class="custom-tooltip-content">
                                                                Trinkaの特定の機能をお使いいただく上で、それぞれ決められたトークン数が必要になります。 
                                                            </div>
                                                        </small>  
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ファイル自動校正<br/>
                                                        (1か月50件まで)<br/>
                                                        <small class="custom-tooltip text-left">
                                                            (Trinkaトークン使用)
                                                            <div class="custom-tooltip-content">
                                                                Trinkaの特定の機能をお使いいただく上で、それぞれ決められたトークン数が必要になります。 
                                                            </div>
                                                        </small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        AIアシスト機能とAI Apps<br/>(1か月3,000件まで) 
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Enterprise Tabs -->
                <div class="tab-pane" [class.active]="activeTab === 'enterprise'" id="Enterprise">
                    <p class="pc-note">
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 5.25L5.41667 9.75L14.75 0.75" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        特に機密性の高い情報・コンテンツを扱うすべてのチームに。
                    </p>
                    <div class="pricingContainer justify-content-center">
                        <!-- Enterprise - CDP-->
                        <div class="pricingCardBox cdpCardBox enterpriseCardBox">
                            <div class="pricingCardHeader sensitiveHeader">
                                <div class="cardTop">
                                    <h2 class="text-white">
                                        <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.8452 4.66573C15.8452 4.2239 15.4869 3.86603 15.0451 3.86603C15.0228 3.86603 15.004 3.86603 14.9896 3.86603C12.9316 3.86603 11.1063 3.15961 9.59726 1.8609C9.25645 1.5676 8.74338 1.5676 8.40257 1.86091C6.89358 3.15957 5.06847 3.86603 3.01051 3.86603C2.99616 3.86603 2.97732 3.86603 2.95493 3.86603C2.51311 3.86603 2.15485 4.22388 2.15483 4.66569C2.15481 5.24485 2.15479 6.02029 2.15479 6.57512C2.15479 11.4468 5.06349 15.5402 9 16.7008C12.9365 15.5402 15.8452 11.4468 15.8452 6.57512C15.8452 6.0203 15.8452 5.24488 15.8452 4.66573Z" fill="#16A34A"/>
                                            <g clip-path="url(#clip0_568_1820)">
                                            <path d="M6.61369 12.9375H11.3864C11.5841 12.9375 11.7444 12.7772 11.7444 12.5795V8.52273C11.7444 8.32504 11.5841 8.16477 11.3864 8.16477H11.0285V7.09091C11.0285 5.97244 10.1185 5.0625 9.00006 5.0625C7.88159 5.0625 6.97165 5.97244 6.97165 7.09091V8.16477H6.61369C6.41601 8.16477 6.25574 8.32504 6.25574 8.52273V12.5795C6.25574 12.7772 6.41601 12.9375 6.61369 12.9375ZM9.35801 10.6701V11.1477C9.35801 11.3454 9.19774 11.5057 9.00006 11.5057C8.80237 11.5057 8.6421 11.3454 8.6421 11.1477V10.6701C8.4973 10.5612 8.40346 10.388 8.40346 10.1932C8.40346 9.86422 8.6711 9.59659 9.00006 9.59659C9.32902 9.59659 9.59665 9.86422 9.59665 10.1932C9.59665 10.388 9.50281 10.5612 9.35801 10.6701ZM7.68756 7.09091C7.68756 6.3672 8.27634 5.77841 9.00006 5.77841C9.72377 5.77841 10.3126 6.3672 10.3126 7.09091V8.16477H7.68756V7.09091Z" fill="white"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_568_1820">
                                            <rect width="7.875" height="7.875" fill="white" transform="translate(5.0625 5.0625)"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                        機密データ保護プラン
                                    </h2>
                                    <p class="mb-0"><b>Teams of 5 or more</b> handling sensitive, regulated, or proprietary content — zero storage, no AI training, full compliance.</p>
                                    
                                </div>
                                <div class="cardButton enterpriseButton">
                                    <button type="button" (click)="navigationService.goToEnterpriseFormSource('/enterprise-cdp')">見積もりを依頼</button>
                                </div>
                            </div>
                            <div class="pricingCardBody">
                                <ul class="badges-list">
                                    <li>SOC2</li>
                                    <li>HIPAA</li>
                                    <li>ISO 27001</li>
                                    <li>GDPR</li>
                                    <li>EU AI Act</li>
                                    <li>ADA</li>
                                </ul>
                                <div class="cardSection">
                                    <div class="innerCard enterpriseCard">
                                        <ul class="v2-checklister">
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        <b>即時データ消去 </b>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        <b>AIによる学習なし</b>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        <b>オフライン文法チェッカーアプリ </b>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        <b>取扱いデータの透明性を確保</b>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        盗用・剽窃チェックライト
                                                        または
                                                        AIコンテンツチェック<br/>
                                                        （年あたり1,000ページまで）
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        盗用・剽窃チェックベーシック （1か月1件まで）
                                                        <small class="custom-tooltip text-left">
                                                            (Trinkaトークン使用)
                                                            <div class="custom-tooltip-content">
                                                                Trinkaの特定の機能をお使いいただく上で、それぞれ決められたトークン数が必要になります。 
                                                            </div>
                                                        </small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ファイル自動校正
                                                        (1か月50件まで)
                                                        <small class="custom-tooltip text-left">
                                                            (Trinkaトークン使用)
                                                            <div class="custom-tooltip-content">
                                                                Trinkaの特定の機能をお使いいただく上で、それぞれ決められたトークン数が必要になります。 
                                                            </div>
                                                        </small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        引用フォーマット調整（年あたり600件） 
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        AIアシスト機能とAI Apps（1か月3,000件まで） 
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        チームの利用状況を把握できるダッシュボード
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ユーザーアクセス管理機能
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        Trinkaの全機能
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Enterprise - Writing Assistance For Teams-->
                        <div class="pricingCardBox enterpriseCardBox">
                            <div class="pricingCardHeader">
                                <div class="cardTop">
                                    <h2>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13 11H17.8C18.9201 11 19.4802 11 19.908 11.218C20.2843 11.4097 20.5903 11.7157 20.782 12.092C21 12.5198 21 13.0799 21 14.2V21M13 21V6.2C13 5.0799 13 4.51984 12.782 4.09202C12.5903 3.71569 12.2843 3.40973 11.908 3.21799C11.4802 3 10.9201 3 9.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.0799 3 6.2V21M22 21H2M6.5 7H9.5M6.5 11H9.5M6.5 15H9.5" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        チーム全員に快適なライティング機能を
                                    </h2>
                                    <p class="mb-0">シーンに合わせてカスタマイズできるプロ仕様の機能を搭載。</p>
                                    
                                </div>
                                <div class="cardButton premiumPlusButton">
                                    <button type="button" (click)="navigationService.goToEnterpriseFormSource('/enterprise-writing')">問い合わせる</button>
                                </div>
                            </div>
                            <div class="pricingCardBody">
                                <div class="cardSection">
                                    <div class="innerCard enterpriseCard">
                                        <ul class="v2-checklister">
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        Trinkaの全機能
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        機能のカスタマイズ
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        より強固なデータセキュリティ
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        チームの利用状況を把握できるダッシュボード
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ユーザーアクセス管理機能
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        API、JavaScript、オンプレミスなど統合オプション
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ホワイトラベル提供
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        現地通貨でのご請求
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Enterprise Tabs -->
                <div class="tab-pane" [class.active]="activeTab === 'institution'" id="Institution">
                    <p class="pc-note">
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 5.25L5.41667 9.75L14.75 0.75" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        One unified platform combining academic integrity and AI writing assistance.
                    </p>
                    <div class="pricingContainer justify-content-center">
                        <div class="institutionPricingPlan">
                            <div class="institutionCardHeader">
                                <div class="cardTop">
                                    <h2>
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_1257_3532)">
                                            <g clip-path="url(#clip1_1257_3532)">
                                            <path d="M3.5 24H24.5M7 20.5V11.1666M11.6667 20.5V11.1666M16.3333 20.5V11.1666M21 20.5V11.1666M23.3333 7.66664L14.4947 2.14247C14.3152 2.03031 14.2255 1.97423 14.1293 1.95237C14.0442 1.93303 13.9558 1.93303 13.8707 1.95237C13.7745 1.97423 13.6848 2.03031 13.5053 2.14247L4.66667 7.66664H23.3333Z" stroke="#FDAF2D" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_1257_3532">
                                            <rect width="28" height="28" fill="white"/>
                                            </clipPath>
                                            <clipPath id="clip1_1257_3532">
                                            <rect width="28" height="28" fill="white" transform="translate(0 -0.5)"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                        Trinka　大学・研究機関向けソリューション
                                    </h2>
                                    <p class="mb-0">学術インテグリティの確保とライティング支援をひとつのソリューションで — 学内全体の学生、教員、アドミニストレーターをサポートします。</p>                              
                                </div>
                                <div class="cardRight">
                                    <h2 class="text-center d-block" style="font-size: 16px;">お客様のニーズに合わせた料金設定</h2>
                                    <div class="btn-group justify-content-center">
                                        <button type="button" (click)="navigationService.goToEnterpriseFormSource('/institution-custom-pricing')">デモをリクエストする</button>
                                    </div>
                                    <small>学部や専攻コースなどの単位での導入も</small>
                                </div>
                            </div>
                            <div class="pricingCardBody">
                                <div class="cardSection">
                                    <div class="innerCard enterpriseCard">
                                        <div class="media">
                                            <div class="media-left">
                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z" fill="#F3EAFF"/>
                                                    <path d="M11.2565 6.94714C10.7955 6.94714 10.3535 7.13024 10.0275 7.45616C9.70165 7.78208 9.51855 8.22412 9.51855 8.68504L9.59071 14.8604C9.92815 14.6881 10.2931 14.5621 10.6769 14.4911L10.6047 8.68504C10.6047 8.51219 10.6734 8.34643 10.7956 8.22421C10.9178 8.10199 11.0836 8.03332 11.2565 8.03332H16.7598V12.7394C16.7598 13.1235 16.9124 13.4918 17.184 13.7635C17.4556 14.0351 17.8239 14.1876 18.208 14.1876H22.9148V22.5853C22.9148 22.7582 22.8462 22.9239 22.724 23.0461C22.6017 23.1684 22.436 23.237 22.2631 23.237H14.5874V24.3232H22.2631C22.7241 24.3232 23.1661 24.1401 23.492 23.8142C23.8179 23.4883 24.001 23.0462 24.001 22.5853V13.8813C24.0008 13.3536 23.7912 12.8476 23.4181 12.4744L18.3992 7.4562C18.0733 7.13028 17.6313 6.94717 17.1703 6.94714H11.2565ZM22.5094 13.1014H18.208C18.112 13.1014 18.0199 13.0633 17.952 12.9955C17.8841 12.9276 17.846 12.8354 17.846 12.7394V8.43884L22.5094 13.1014Z" fill="#6E00A1"/>
                                                    <path d="M19.5424 20.3435H16.4934C16.2434 20.3435 16.0361 20.0973 16.0361 19.8004C16.0361 19.5035 16.2434 19.2573 16.4934 19.2573H19.5424C19.7924 19.2573 19.9997 19.5035 19.9997 19.8004C19.9997 20.0973 19.7924 20.3435 19.5424 20.3435Z" fill="#6E00A1"/>
                                                    <path d="M21.3718 17.4467H16.4934C16.2434 17.4467 16.0361 17.2005 16.0361 16.9036C16.0361 16.6067 16.2434 16.3605 16.4934 16.3605H21.3718C21.6218 16.3605 21.8292 16.6067 21.8292 16.9036C21.8292 17.2005 21.6218 17.4467 21.3718 17.4467Z" fill="#6E00A1"/>
                                                    <path d="M10.6058 15.7172C9.88532 15.8808 9.24197 16.2845 8.78138 16.8621C8.3208 17.4396 8.07039 18.1567 8.07129 18.8954C8.07082 19.3234 8.15477 19.7474 8.31836 20.1429C8.48195 20.5386 8.72196 20.898 9.02464 21.2006C9.32732 21.5033 9.68672 21.7433 10.0823 21.9069C10.4779 22.0705 10.9018 22.1545 11.3298 22.1539C11.7886 22.1542 12.2423 22.0575 12.6612 21.8703C13.08 21.6831 13.4546 21.4095 13.7604 21.0675C14.0662 20.7255 14.2964 20.3228 14.4358 19.8857C14.5752 19.4486 14.5695 18.531 14.5695 18.531C14.5695 18.531 14.3712 17.6352 14.1381 17.24C13.905 16.8448 13.5911 16.5033 13.2169 16.2378C12.8428 15.9723 12.4168 15.7889 11.9668 15.6994C11.5168 15.6099 11.053 15.6165 10.6058 15.7187M10.5804 24.1895L11.3306 23.6029L13.0446 24.9448C13.1195 25.0035 13.2094 25.04 13.3041 25.05C13.3988 25.06 13.4943 25.0431 13.5799 25.0013C13.6654 24.9596 13.7375 24.8945 13.7878 24.8137C13.838 24.7329 13.8646 24.6395 13.8643 24.5443V21.9664C13.1515 22.5563 12.4348 22.4133 11.5096 22.4123C11.2764 22.4118 10.9763 22.4504 10.7552 22.4123C10.0736 22.2951 9.32791 22.4084 8.79542 21.9672V24.5443C8.79552 24.6393 8.82233 24.7324 8.87279 24.8129C8.92325 24.8934 8.99532 24.9581 9.08078 24.9996C9.16625 25.0412 9.26166 25.0578 9.35614 25.0477C9.45062 25.0376 9.54036 25.0012 9.61512 24.9426L10.5804 24.1895Z" fill="#16A34A"/>
                                                    <path d="M10.2441 19.3164L10.7662 19.8384L12.0713 18.5333" stroke="#6E00A1" stroke-width="0.754398" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M11.4942 15.5755C11.6585 15.5939 11.8189 15.6395 11.9687 15.7111L11.968 15.7118C12.1668 15.8066 12.3374 15.9593 12.4556 16.0603L12.4902 16.0912C12.5031 16.0923 12.5178 16.0933 12.5367 16.0949C12.6934 16.1072 12.9224 16.1181 13.1298 16.1914L13.129 16.1921C13.2854 16.2474 13.431 16.3279 13.56 16.4308L13.6838 16.5406L13.7935 16.6644C13.8623 16.7505 13.9216 16.8437 13.9696 16.9428L14.033 17.0953L14.0337 17.0961C14.1034 17.2938 14.1159 17.5043 14.1273 17.6456L14.1302 17.6825V17.6877C14.1317 17.7062 14.1329 17.7209 14.1339 17.7334C14.1409 17.7418 14.1494 17.7514 14.1597 17.7636L14.1649 17.7702L14.1686 17.7739C14.2672 17.8898 14.4193 18.059 14.5133 18.255L14.5141 18.2556C14.6095 18.4553 14.6591 18.6739 14.6591 18.8951C14.6591 19.1164 14.6094 19.335 14.5141 19.5346L14.5133 19.5339C14.4189 19.7319 14.2656 19.9029 14.1663 20.0194L14.1641 20.0216L14.1567 20.0297L14.1494 20.0385C14.144 20.0445 14.139 20.0508 14.1339 20.0569C14.1329 20.0694 14.1317 20.0841 14.1302 20.1026V20.1085C14.118 20.2608 14.106 20.4893 14.033 20.6957C13.9592 20.904 13.8401 21.0935 13.6838 21.2497C13.5279 21.4054 13.3388 21.5237 13.1313 21.5974C12.9232 21.6716 12.6932 21.6833 12.5389 21.6954L12.5397 21.6962C12.52 21.6977 12.5048 21.698 12.4918 21.6991C12.4856 21.7042 12.4792 21.7092 12.4734 21.7146L12.4645 21.7226L12.4549 21.7308C12.3364 21.8316 12.1668 21.9849 11.9702 22.0792C11.7706 22.1747 11.5512 22.2243 11.33 22.2244C11.1092 22.2244 10.8912 22.1749 10.692 22.08C10.4926 21.9852 10.322 21.8313 10.2035 21.73L10.1947 21.7226L10.1865 21.7153C10.1806 21.7099 10.1736 21.705 10.1674 21.6998C10.1595 21.6991 10.1517 21.698 10.1438 21.6976L10.1217 21.6962C9.96502 21.6839 9.73668 21.6722 9.52942 21.5989C9.32114 21.5253 9.13167 21.4059 8.97541 21.2497C8.819 21.0934 8.69922 20.9041 8.62547 20.6957C8.55245 20.4893 8.54112 20.2608 8.52896 20.1085V20.1041L8.52748 20.0923L8.52675 20.0798C8.52635 20.0716 8.52528 20.0636 8.52454 20.0555L8.49949 20.0267L8.49359 20.0201L8.49433 20.0194L8.49065 20.0164C8.39193 19.9005 8.23985 19.7313 8.14586 19.5353L8.14513 19.5346C8.07352 19.3848 8.02796 19.2244 8.00957 19.0601L8 18.8951L8.00957 18.7301C8.02799 18.5659 8.07352 18.4055 8.14513 18.2556C8.23963 18.0587 8.39289 17.8884 8.49433 17.7694L8.49949 17.7636C8.50981 17.7514 8.51817 17.7418 8.52527 17.7334C8.52631 17.7209 8.52677 17.7062 8.52822 17.6877L8.52896 17.6862V17.6825C8.54118 17.5295 8.55284 17.3022 8.62547 17.0961C8.69928 16.8875 8.81957 16.697 8.97614 16.5406L9.09918 16.4301C9.22793 16.3275 9.37346 16.2472 9.52942 16.1921C9.73658 16.1188 9.96501 16.1064 10.1217 16.0941C10.1403 16.0926 10.1548 16.0923 10.1674 16.0912C10.1769 16.0831 10.188 16.0738 10.202 16.0617L10.2043 16.0595C10.3228 15.9587 10.4924 15.8061 10.689 15.7118L10.6897 15.7111C10.8893 15.6156 11.108 15.5659 11.3292 15.5659L11.4942 15.5755Z" fill="#16A34A" stroke="#16A34A" stroke-width="1.59"/>
                                                    <path d="M10.4844 18.8762L11.0345 19.4263L12.4096 18.0511" stroke="white" stroke-width="0.754398" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </div>
                                            <div class="media-body">
                                                <h3>DocuMark</h3>
                                                <span>学術インテグリティ</span>
                                            </div>
                                        </div>
                                        <p>責任あるAI利用を推進。教員の人の目による監督を効率化し、教育・指導を支援します。</p>
                                        <ul class="v2-checklister">
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        執筆過程の記録
                                                        <small class="d-block">執筆パターンや分析データを収集します</small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        オーナーシップスコア
                                                        <small class="d-block">自身の力での執筆や修正等に基づいてスコアを算出します</small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        AI／コピー＆ペーストチェック
                                                        <small class="d-block">AI生成文や貼り付け文章をフラグ付けします</small>
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#F3EAFF"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#7B2FBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        オーサーシップ認証
                                                        <small class="d-block">改訂履歴の確認、執筆過程の再現が可能です</small>
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="cardSection">
                                    <div class="innerCard enterpriseCard">
                                        <div class="media">
                                            <div class="media-left">
                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z" fill="#ECFDF5"/>
                                                    <g clip-path="url(#clip0_1257_3602)">
                                                    <path d="M11 21L10 22L11 17L20 8L24 12L15 21H11Z" stroke="#10B981" stroke-width="1.3" stroke-linejoin="round"/>
                                                    <path d="M19 11L21 13" stroke="#10B981" stroke-width="1.3"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_1257_3602">
                                                    <rect width="16" height="16" fill="white" transform="translate(8 8)"/>
                                                    </clipPath>
                                                    </defs>
                                                </svg> 
                                            </div>
                                            <div class="media-body">
                                                <h3>執筆支援</h3>
                                                <span class="sensitive">学生・教員向けサポート</span>
                                            </div>
                                        </div>
                                        <p>すべての学生、研究者、教員のためのプロフェッショナルなAIライティングツール</p>
                                        <ul class="v2-checklister v2-checklister1">
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        文法・言語の正確さ確保
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        スタイルガイドに基づく修正
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        パラフレーズ・一貫性チェック機能
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        引用チェッカー・引用フォーマット
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        テクニカルチェック
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        ジャーナルファインダー
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="tx-list-wrapper gap-10">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#D7FDDA"/>
                                                        <path d="M6 9L8 11L12 7" stroke="#3EAB43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span class="text-left">
                                                        AI支援ライティング <span class="badge">オプション</span>
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="institutionFooter">
                                <h4>プラットフォーム全体：</h4>
                                <ul>
                                    <li>
                                        <span>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 1.5L11.5 3.94444V7.2037C11.5 9.64815 9.53636 11.7667 7 12.5C4.46364 11.7667 2.5 9.64815 2.5 7.2037V3.94444L7 1.5Z" stroke="#7B2FBE" stroke-width="1.2"/>
                                            </svg>
                                            SOC2 · HIPAA · FERPA · GDPR · ISO認証取得
                                        </span>
                                        <span>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 5H3C2.17157 5 1.5 5.67157 1.5 6.5V11.5C1.5 12.3284 2.17157 13 3 13H11C11.8284 13 12.5 12.3284 12.5 11.5V6.5C12.5 5.67157 11.8284 5 11 5Z" stroke="#7B2FBE" stroke-width="1.2"/>
                                                <path d="M4.5 4.92188V4.42188C4.5 3.75883 4.76339 3.12295 5.23223 2.65411C5.70107 2.18527 6.33696 1.92188 7 1.92188C7.66304 1.92188 8.29893 2.18527 8.76777 2.65411C9.23661 3.12295 9.5 3.75883 9.5 4.42188V4.92188" stroke="#7B2FBE" stroke-width="1.2"/>
                                            </svg>
                                            導入サポートおよびアカウントサポート
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 12.5C10.0376 12.5 12.5 10.0376 12.5 7C12.5 3.96243 10.0376 1.5 7 1.5C3.96243 1.5 1.5 3.96243 1.5 7C1.5 10.0376 3.96243 12.5 7 12.5Z" stroke="#7B2FBE" stroke-width="1.2"/>
                                                <path d="M4.5 7L6.5 9L9.5 6" stroke="#7B2FBE" stroke-width="1.2" stroke-linecap="round"/>
                                            </svg>
                                            学生のデータ保護
                                        </span>
                                        <span>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 2H4C2.89543 2 2 2.89543 2 4V10C2 11.1046 2.89543 12 4 12H10C11.1046 12 12 11.1046 12 10V4C12 2.89543 11.1046 2 10 2Z" stroke="#7B2FBE" stroke-width="1.2"/>
                                                <path d="M5 7H9M7 5V9" stroke="#7B2FBE" stroke-width="1.2" stroke-linecap="round"/>
                                            </svg>
                                            LMSおよびSSOとの連携 — Canvas、Moodle、Blackboard、D2Lなどに対応
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="compareLinkAccess">
    <p (click)="scroll(target)">両プランの機能の比較</p>
    <a (click)="scroll(target)">
        <img src="assets/images/PricingDownArrow.png" alt="icon" />
    </a>
</section>

<section class="globalLogo">
    <app-global-leaders 
        [clientLogos]="customLogos"
    >
    </app-global-leaders>
</section>

<section class="section-pd bg-light-purple">
    <div class="trinka_container">
        <div class="row match-box justify-content-center">
            <div class="col-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Testimonials</h2>
                </div>
            </div>
            <div class="col-md-10 col-lg-10">
                <div class="review-snippet mt-40">
                    <div class="snippet-slider">
                        <span class="quotes">
                            <img src="../../../assets/images/double_quotes_icon.png" width="46" height="32" alt="icon" />
                        </span>
                        <div id="testimonialSlider" class="carousel slide" data-ride="carousel">
                            <!-- <ol class="carousel-indicators">
                                <li *ngFor="let testimonial of testimonials; let i = index" [attr.data-target]="'#snippetSlider'" [attr.data-slide-to]="i" [class.active]="i === 0"></li>
                            </ol> -->
                            <div class="carousel-inner">
                                <div *ngFor="let testimonial of currentTestimonials; let i = index" class="carousel-item" [class.active]="i === 0">
                                    <div class="snippet-content">
                                        <p class="stm">{{ testimonial.message }}</p>
                                        <div class="media">
                                            <div class="media-left">
                                                <img src="../../../assets/images/{{ testimonial.photo }}" loading="lazy" decoding="async" alt="{{ testimonial.author }} - testimonial" />
                                            </div>
                                            <div class="media-body">
                                                <span class="authorName">{{ testimonial.author }}</span>
                                                <p [innerHTML]="testimonial.designation"></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#testimonialSlider" data-slide="prev" aria-label="prev">
                            <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15 7L10 12L15 17" stroke="#878787" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                        </a>
                        <a class="carousel-control-next" href="#testimonialSlider" data-slide="next" aria-label="next">
                            <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(180)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15 7L10 12L15 17" stroke="#878787" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="pricingTableSectioni section-pd" #target>
    <div class="container pricing-container">
        <div class="row">
            <div class="col-12">
                <div class="table-container" [class.sticky]="isSticky" style="position: relative;">
                    <div class="mainContainer">
                        <div class="hiddenHeader"></div>
                        <table>
                            <thead>
                                <tr>
                                    <th class="benefits_title"></th>
                                    <th>
                                        <div class="pricingCardHeader">
                                            <div class="cardTop">
                                                <h2>ベーシック</h2>
                                                <div class="amount justify-content-center">
                                                    <div class="amt_div">
                                                        <b>&#x20B9;</b>
                                                        <h3>0</h3>
                                                        <span>/1か月</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="cardButton">
                                                <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">さっそく始める</a>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="empty_th"></th>
                                    <th>
                                        <div class="pricingCardHeader premiumCardHeader">
                                            <div class="cardTop" *ngIf="decodedData && decodedData.length > 0">
                                                <h2>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path
                                                            d="M22.3741 8.70322L18.8221 3.34066C18.6809 3.12817 18.4423 3 18.1871 3H5.81368C5.55826 3 5.31983 3.12817 5.17863 3.34066L1.62667 8.70322C1.43714 8.98817 1.46244 9.36422 1.68821 9.62054L11.4273 20.7403C11.5712 20.9055 11.78 21 11.9999 21C12.2198 21 12.4286 20.9055 12.5732 20.7395L22.3123 9.61979C22.5373 9.3642 22.5626 8.98816 22.3741 8.70322ZM7.69844 9.88101L10.0589 16.8716L3.93597 9.88101H7.69844ZM13.7561 4.51844L14.7768 8.36335H9.22124L10.2419 4.51844H13.7561ZM14.6939 9.88101L11.9995 17.8627L9.30518 9.88101H14.6939ZM16.3007 9.88101H20.0634L13.9405 16.8716L16.3007 9.88101ZM20.3239 8.36253H16.3525L15.3318 4.51763H17.7775L20.3239 8.36253ZM6.22237 4.5184H8.6681L7.64741 8.3633H3.67506L6.22237 4.5184Z"
                                                            fill="#7A28A0"
                                                        />
                                                    </svg>
                                                    プレミアム
                                                </h2>
                                                <div class="amount" *ngIf="decodedData && decodedData.length > 0">
                                                    <div id="yearly" class="amt_div" *ngIf="isYearlyChecked; else monthlyContent">
                                                        <b>{{decodedData[0].currency}}</b>
                                                        <h3>
                                                            {{decodedData[2].final_amount| number:'1.0-0'}}
                                                        </h3>
                                                        <span>/1か月</span>
                                                    </div>
                                                </div>
                                                <ng-template #monthlyContent>
                                                    <div id="monthly" class="amt_div">
                                                        <b>{{decodedData[0].currency}}</b><h3>{{decodedData[2].amount| number:'1.0-0'}}</h3><span>/1か月</span>
                                                        <!-- <b>$</b><h3>20</h3><span>per month</span> -->
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <div class="cardButton premiumButton">
                                                <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">さっそく始める</a>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="empty_th"></th>
                                    <th>
                                        <div class="pricingCardHeader premiumPlusCardHeader">
                                            <div class="cardTop" *ngIf="decodedData && decodedData.length > 0">
                                                <h2>
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M20.898 9.43584L18.0227 5.26495C17.9083 5.09969 17.7152 5 17.5086 5H7.49202C7.28526 5 7.09225 5.09969 6.97793 5.26495L4.10254 9.43584C3.94911 9.65746 3.96959 9.94995 4.15236 10.1493L12.0364 18.798C12.1529 18.9265 12.3219 19 12.4999 19C12.678 19 12.847 18.9265 12.964 18.7974L20.8481 10.1487C21.0302 9.94994 21.0507 9.65746 20.898 9.43584ZM9.01778 10.3519L10.9286 15.789L5.97198 10.3519H9.01778ZM13.9216 6.18101L14.7479 9.1715H10.2505L11.0768 6.18101H13.9216ZM14.6808 10.3519L12.4996 16.5599L10.3185 10.3519H14.6808ZM15.9816 10.3519H19.0275L14.0708 15.789L15.9816 10.3519ZM19.2384 9.17086H16.0234L15.1971 6.18038H17.177L19.2384 9.17086ZM7.82287 6.18097H9.80274L8.97647 9.17146H5.76076L7.82287 6.18097Z" fill="#763393"/>
                                                        <path d="M4.375 0.5625L5.08399 2.47851L7 3.1875L5.08399 3.89649L4.375 5.8125L3.66601 3.89649L1.75 3.1875L3.66601 2.47851L4.375 0.5625Z" fill="#763393"/>
                                                        <path d="M1.75 4.9375L2.22266 6.21484L3.5 6.6875L2.22266 7.16016L1.75 8.4375L1.27734 7.16016L0 6.6875L1.27734 6.21484L1.75 4.9375Z" fill="#763393"/>
                                                    </svg>
                                                    プレミアムプラス
                                                </h2>
                                                <div class="amount justify-content-center">
                                                    <div class="amt_div" *ngIf="isYearlyChecked">
                                                        <b>{{decodedData[0].currency}}</b>
                                                        <h3>
                                                            {{decodedData[3].final_amount | number:'1.0-0'}}
                                                        </h3>
                                                        <span>/1か月</span>
                                                        <!-- <h3>{{decodedData[0].amount | number:'1.2-2'}}</h3><span>per month</span> -->
                                                        <!-- <b>$</b><h3>8.33</h3><span>per month</span> -->
                                                    </div>
                                                    <div class="amt_div" *ngIf="!isYearlyChecked">
                                                        <b>{{decodedData[0].currency}}</b>
                                                        <h3>
                                                            {{ decodedData[3].amount | number:'1.0-0' }}<small>{{ (decodedData[3].amount % 1).toFixed(2).substring(1) }}</small>
                                                        </h3>
                                                        <span>/1か月</span>
                                                        <!-- <h3>{{decodedData[0].amount | number:'1.2-2'}}</h3><span>per month</span> -->
                                                        <!-- <b>$</b><h3>8.33</h3><span>per month</span> -->
                                                    </div>
                                                </div>
                                                <div class="infoContainer" *ngIf="decodedData && decodedData.length > 0">
                                                    <p *ngIf="!isYearlyChecked" class="text-center">年払い年額 {{decodedData[0].currency}}{{decodedData[3].final_amount | number:'1.0-0'}} </p>
                                                    <!-- <span>Save upto {{decodedData[0].currency}}{{decodedData[0].currency=='$'?'36 ':'2880 '}}with every plagiarism check</span> -->
                                                </div>
                                            </div>
                                            <div class="cardButton premiumPlusButton">
                                                <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">さっそく始める</a>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="empty_th"></th>
                                    <th>
                                        <div class="pricingCardHeader premiumCardHeader sensitiveHeader">
                                            <div class="cardTop">
                                                <h2 class="justify-content-center" style="color: #15803D">
                                                    <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15.8452 4.66573C15.8452 4.2239 15.4869 3.86603 15.0451 3.86603C15.0228 3.86603 15.004 3.86603 14.9896 3.86603C12.9316 3.86603 11.1063 3.15961 9.59726 1.8609C9.25645 1.5676 8.74338 1.5676 8.40257 1.86091C6.89358 3.15957 5.06847 3.86603 3.01051 3.86603C2.99616 3.86603 2.97732 3.86603 2.95493 3.86603C2.51311 3.86603 2.15485 4.22388 2.15483 4.66569C2.15481 5.24485 2.15479 6.02029 2.15479 6.57512C2.15479 11.4468 5.06349 15.5402 9 16.7008C12.9365 15.5402 15.8452 11.4468 15.8452 6.57512C15.8452 6.0203 15.8452 5.24488 15.8452 4.66573Z" fill="#16A34A"/>
                                                        <g clip-path="url(#clip0_568_1820)">
                                                        <path d="M6.61369 12.9375H11.3864C11.5841 12.9375 11.7444 12.7772 11.7444 12.5795V8.52273C11.7444 8.32504 11.5841 8.16477 11.3864 8.16477H11.0285V7.09091C11.0285 5.97244 10.1185 5.0625 9.00006 5.0625C7.88159 5.0625 6.97165 5.97244 6.97165 7.09091V8.16477H6.61369C6.41601 8.16477 6.25574 8.32504 6.25574 8.52273V12.5795C6.25574 12.7772 6.41601 12.9375 6.61369 12.9375ZM9.35801 10.6701V11.1477C9.35801 11.3454 9.19774 11.5057 9.00006 11.5057C8.80237 11.5057 8.6421 11.3454 8.6421 11.1477V10.6701C8.4973 10.5612 8.40346 10.388 8.40346 10.1932C8.40346 9.86422 8.6711 9.59659 9.00006 9.59659C9.32902 9.59659 9.59665 9.86422 9.59665 10.1932C9.59665 10.388 9.50281 10.5612 9.35801 10.6701ZM7.68756 7.09091C7.68756 6.3672 8.27634 5.77841 9.00006 5.77841C9.72377 5.77841 10.3126 6.3672 10.3126 7.09091V8.16477H7.68756V7.09091Z" fill="white"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0_568_1820">
                                                        <rect width="7.875" height="7.875" fill="white" transform="translate(5.0625 5.0625)"/>
                                                        </clipPath>
                                                        </defs>
                                                    </svg>
                                                    機密データ保護プラン
                                                </h2>
                                                <div class="amount justify-content-center">
                                                    <div class="amt_div" *ngIf="isYearlyChecked">
                                                        <b>$</b><h3>500 </h3><span>annually</span>
                                                    </div>
                                                    <div class="amt_div" *ngIf="!isYearlyChecked">
                                                        <b>$</b><h3>41<small>.67</small></h3><span>/1か月</span>
                                                    </div>
                                                </div>
                                                <div class="infoContainer">
                                                    <p *ngIf="!isYearlyChecked" class="text-center" style="color: #4f4f4f;">年払い年額 $500</p>
                                                </div>
                                            </div>
                                            <div class="cardButton premiumButton">
                                                <button type="button" (click)="navigationService.goToEnterpriseForm()">さっそく始める</button>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="noBorder">
                                    <td colspan="8" class="no-padding">&nbsp;</td>
                                </tr>

                                <!-- Writing Assistance Starts -->
                                <tr class="purple-bg noBorder bold">
                                    <td>
                                        <h5>執筆支援<small>／月</small></h5>
                                    </td>
                                    <td>
                                        5000単語
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        フルアクセス
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        フルアクセス
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        フルアクセス
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            文法チェック
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(Lite Modeのみ)</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(Lite ModeおよびPower Mode)</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(Lite ModeおよびPower Mode)</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(Lite ModeおよびPower Mode)</span>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            スタイルガイドに基づく修正
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(APA, AMA, ACS, AGU, IEEE)</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(APA, AMA, ACS, AGU, IEEE)</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(APA, AMA, ACS, AGU, IEEE)</span>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            パラフレーズ機能
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(Standard Modeのみ)</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(全モード)</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(全モード)</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">(全モード)</span>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            翻訳
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            クラウドからのファイルのダウンロード
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            専門用語のスペルチェック
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            一貫性チェック
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            不適切な表現のチェック
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>


                                <tr class="noBorder">
                                    <td>
                                        <h6>
                                            マイディクショナリー
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>
                                <!-- Writing Assistance End -->

                                <!-- Proofread Starts -->
                                <tr class="purple-bg noBorder bold">
                                    <td>
                                        <h5>ファイル一括校正</h5>
                                        <span>（MS WodrおよびLaTex）</span>
                                    </td>
                                    <td>
                                        4ファイルまで
                                        <span class="text-center">（トークンを使用）</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        10ファイルまで
                                        <span class="text-center">（トークンを使用）</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        20ファイルまで
                                        <span class="text-center">（トークンを使用）</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        50ファイルまで
                                        <span class="text-center">（トークンを使用）</span>
                                    </td>
                                </tr>

                                <tr class="noBorder">
                                    <td>
                                        <h6>
                                            校正済みファイルの編集権限
                                        </h6>
                                    </td>
                                    <td>
                                        読み取り専用
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        編集可能
                                        <span class="text-center">（変更履歴付き）</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        編集可能 
                                        <span class="text-center">（変更履歴付き）</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        編集可能 
                                        <span class="text-center">（変更履歴付き）</span>
                                    </td>
                                </tr>
                                <!-- Proofread Ends -->

                                <!-- AI Content Starts -->
                                <tr class="purple-bg noBorder bold">
                                    <td>
                                        <h5>AI文章生成</h5>
                                    </td>
                                    <td>
                                        5回
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        25回 
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        1000回 
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        3000回
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            AI執筆支援
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>

                                <tr class="noBorder">
                                    <td>
                                        <h6>
                                            AIエージェント
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>
                                <!-- AI Content Ends -->

                                <!-- Credits Starts -->
                                <tr class="purple-bg noBorder bold">
                                    <td>
                                        <h5>進呈トークン<small>／月</small></h5>
                                    </td>
                                    <td>
                                        4
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        10
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        20
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        50
                                    </td>
                                </tr>

                                <tr class="noBorder">
                                    <td>
                                        <h6>
                                            ご購入いただいたトークン（Credit）は有効期限なし
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        最大64％
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        最大64％
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        最大64％
                                    </td>
                                </tr>
                                <!-- Credits Ends -->

                                <!-- Data Privacy Starts -->
                                <tr class="purple-bg noBorder bold">
                                    <td>
                                        <h5>データプライバシー</h5>
                                    </td>
                                    <td>
                                        スタンダード
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        アドバンス
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        アドバンス
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        アドバンス
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            データ自動消去
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        90日後
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        90日後
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        リアルタイム
                                    </td>
                                </tr>

                                <tr class="noBorder">
                                    <td>
                                        <h6>
                                            AI学習へのデータ不使用
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>
                                <!-- Data Privacy Ends -->

                                <!-- Reports Starts -->
                                <tr class="purple-bg noBorder bold">
                                    <td>
                                        <h5>レポート</h5>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            盗用・剽窃スコア
                                        </h6>
                                    </td>
                                    <td>
                                        1回／月
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        2回／月
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        2回／月
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        2回／月
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            盗用・剽窃チェック（スタンダード）
                                        </h6>
                                    </td>
                                    <td>
                                        24トークン／レポート
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        24トークン／レポート
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        最大240ページ／年
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        最大1000ページ／年
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            盗用・剽窃チェック（アドバンス）
                                        </h6>
                                    </td>
                                    <td>
                                        36トークン／レポート
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        36トークン／レポート
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        36トークン／レポート
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        36トークン／レポート
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            AI生成コンテンツ検出
                                        </h6>
                                    </td>
                                    <td>
                                        1トークン（Credt）<br/>／5000単語
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        1トークン（Credt）<br/>／5000単語
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        最大240ページ／年
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        最大1000ページ／年
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            引用チェックツール
                                        </h6>
                                    </td>
                                    <td>
                                        1トークン（Credt）<br/>／30文献
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        1トークン（Credt）<br/>／30文献
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        1トークン（Credt）<br/>／30文献
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        1トークン（Credt）<br/>／30文献
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            引用フォーマットツール
                                        </h6>
                                    </td>
                                    <td>
                                        1トークン（Credt）<br/>／30文献
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        1トークン（Credt）<br/>／30文献
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        600文献／年
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        600文献／年
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            ファイル一括翻訳
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        5トークン<br/>／50000文字
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        5トークン<br/>／50000文字
                                    </td>
                                </tr>

                                <tr class="noBorder">
                                    <td>
                                        <h6>
                                            ジャーナルファインダー
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>
                                <!-- Reports Ends -->

                                <!-- Access Start -->
                                <tr class="purple-bg noBorder bold">
                                    <td>
                                        <h5>アクセス</h5>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            クラウド
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            ブラウザプラグイン
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>

                                <!-- <tr>
                                    <td>
                                        <h6>
                                            MS Word Add-ins
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr> -->

                                <tr>
                                    <td>
                                        <h6>
                                            デスクトップアプリ
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            オフライン文法チェックアプリ
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>

                                <tr class="noBorder">
                                    <td>
                                        <h6>
                                            新機能への早期アクセス
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/close-circle.svg" alt="Not checked">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>
                                <!-- Access Ends -->

                                <!-- Other Starts -->
                                <tr class="purple-bg noBorder bold">
                                    <td>
                                        <h5>エナゴの他のAI製品へのアクセス</h5>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td aria-hidden="true" role="presentation"></td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            <a href="https://www.read.enago.com/jp/" target="_blank" class="text-link">Enago Read（エナゴリード）</a> 
                                            <span>(Copilot, サマライザー, 重要なポイントの抽出, 読むべき文献の特定)</span>
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h6>
                                            <a href="https://www.reports.enago.com/" target="_blank" class="text-link">Enago Reports</a> 
                                            <span>（原稿の評価・改善に使えるAIレポート）</span>
                                        </h6>
                                    </td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">月あたり4トークン（Credit）</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">月あたり10トークン（Credit）</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">月あたり20トークン（Credit）</span>
                                    </td>
                                    <td aria-hidden="true" role="presentation"></td>
                                    <td>
                                        <img src="assets/images/tick-circle.svg" alt="check">
                                        <span class="text-center">月あたり50トークン（Credit）</span>
                                    </td>
                                </tr>
                                <!-- Other Ends -->

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <small class="mt-1" style="font-style: italic; display: block; text-align: right;">*「盗用・剽窃チェック（スタンダード）」と「AIコンテンツ検出レポート」の併用の場合</small>
            </div>
        </div>
    </div>
</section>


<div class="faqQuestionAnwser section-pd pt-0" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>よくあるご質問</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinkaの「プレミアム」プランと「プレミアムプラス」プランの違いとは
                                    </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>主な違いとして「プレミアムプラス」では、最大240ページ（1ページあたり250単語）分の「盗用・剽窃チェック（スタンダード）」または「AIコンテンツ検出レポート」が含まれている点です。「プレミアム」プランでは、「盗用・剽窃チェック（スタンダード）」の実行のためには、別途トークン（Credit）の購入が必要です。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">Trinkaのベーシックプラン（無料プラン）に有効期限はあるか？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaのベーシックプランに有効期限はありませんが、1か月あたりの各種機能の使用量は限定的です。</p>
                                        <p>プレミアムプランへのアップグレードで、機能利用の回数や英文チェック・パラフレーズのご利用単語数を増やすことができます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Trinkaをどの程度使用するか分からない場合に最適なプランは？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>まずは無料のベーシックプランから始めていただくことをお勧めします。
                                        </p>
                                        <p>無料でのご利用枠を使い切られた後に継続してご利用いただける場合、プレミアムプランまたはプレミアムプラスプランへのアップグレードをご検討ください。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Trinkaのアカウント作成にクレジットカードの登録は必要か？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>ベーシックプランへのご登録とご利用には、クレジットカード情報は必要ありません。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        Trinkaのベーシックプランの月間利用制限はどのように適用されるか？ 
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>ご登録された日を起日に1か月ずつ期間が設定されご利用制限がかけられます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        Trinkaのベーシックプランの月間利用枠に達した場合どうなるか？
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>毎月のご利用枠を使い切られた場合、同じ月に継続してTrinkaをご利用いただくことはできません。</p>
                                        <p>プレミアムプランにアップグレードいただけば、同日から継続してのご利用が可能です。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        Trinkaでの盗用・剽窃チェック、ファイル自動校正、引用チェックツール、出版適正チェックなどに使えるTrinkaトークンは追加購入できるか？ 
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>ベーシックプランとプレミアムプランのユーザー様に向けて追加のパックをご用意しています。</p>
                                        <p>ご購入いただいた追加Trinkaトークンに有効期限はありません。</p>
                                        <p>Trinkaトークンとご購入いただけるパックの詳細については、<a href="/features/credits" class="text-link">こちらをクリックし</a>てください。</p>
                                       
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="card">
                                <div class="card-header" id="QuestionPL">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionPLContent" aria-expanded="true" aria-controls="QuestionPLContent">
                                        Can I have access to Plagiarism Check, Proofread File, Citation Checker or Technical Checks with a basic plan? 
                                    </a>
                                </div>

                                <div id="QuestionPLContent" class="collapse" aria-labelledby="QuestionPL" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            Trinka Basic plan subscribers can access most of Trinka’s features. They can also purchase additional credits whenever they need higher usage limits.
                                        </p>
                                    </div>
                                </div>
                            </div> -->

                            <div class="card">
                                <div class="card-header" id="Question13">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question13Content" aria-expanded="true"
                                        aria-controls="Question13Content">
                                        サポートが必要な場合は？
                                    </a>
                                </div>

                                <div id="Question13Content" class="collapse" aria-labelledby="Question13" data-parent="#faq">
                                    <div class="card-body">
                                        <p>ご不明な点がございましたら、<a href="mailto:support&#64;trinka&#46;ai">メールにてお問い合わせ</a>ください。</p>
                                       
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFourteenSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourteenSectionContent" aria-expanded="true"
                                        aria-controls="QuestionFourteenSectionContent">
                                        Trinkaに無料トライアルはあるか？
                                    </a>
                                </div>

                                <div id="QuestionFourteenSectionContent" class="collapse" aria-labelledby="QuestionFourteenSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>まずはベーシックプランにご登録いただければ、有料プランご登録前のトライアルとしてTrinkaの英文チェック・パラフレーズ等の機能を体験いただけます。</p>
                                        <p>高度な機能のご利用やご利用枠の拡張をご希望の場合は、有料プランへの登録をご検討ください。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            
                            <div class="card">
                                <div class="card-header" id="QuestionEightSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true"
                                        aria-controls="QuestionEightSectionContent">
                                        Trinkaのプレミアムプランを解約した場合、購入済みのTrinkaトークンはどうなるか？
                                    </a>
                                </div>

                                <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>ご購入いただいたトークンは、プレミアムプラン解約後でも、いつでもご利用いただけます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                        aria-controls="QuestionEightContent">
                                        プラン変更はいつでもできるか？
                                    </a>
                                </div>

                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>いつでも変更いただけます。
                                        </p>
                                        <p>月額プランから年額プランへの移行の場合、月額に対する日割分を差し引いた額をお支払いいただくこととなります。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true"
                                        aria-controls="QuestionTenContent">
                                        Trinkaの登録をキャンセルしたり、自動更新を停止できるか？ 
                                    </a>
                                </div>

                                <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>ご登録の解約、自動更新の停止はいつでも可能です。<br/>ただし、契約期間の満了まで登録自体は継続されます。<br/>そのため、キャンセルに伴う返金は行えません。</p>
                                        <p class="mb-2">自動更新の停止は、以下の手順で行ってください：</p>

                                            <ol>
                                                <li>Trikaのアカウントに<a href="https://cloud.trinka.ai/signin?_rg=JP" class="text-link" target="_blank" rel="noopener noreferrer">サインイン</a></li>
                                                <li>ダッシュボード右上にある「アカウント設定」ボタンをクリック</li>
                                                <li>Click on the “cancel subscription renewal” link given in the subscription.</li>
                                            </ol>
                                        

                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="Question11">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question11Content" aria-expanded="true"
                                        aria-controls="Question11Content">
                                        Trinkaではどのようにしてデータの安全性を守っているのか？
                                    </a>
                                </div>

                                <div id="Question11Content" class="collapse" aria-labelledby="Question11" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaでは、ユーザーのデータはすべて高度に暗号化され、安全に保管されます。データへアクセスできるのはユーザー本人に限られます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="Question12">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question12Content" aria-expanded="true"
                                        aria-controls="Question12Content">
                                        Trinkaをグループで使いたい場合には？
                                    </a>
                                </div>

                                <div id="Question12Content" class="collapse" aria-labelledby="Question12" data-parent="#faq">
                                    <div class="card-body">
                                        <p>チーム、グループでのTrikaのご利用は6ユーザー以上からお申込みいただけます。</p>
                                        <p><a (click)="navigationService.goToEnterpriseForm()" class="text-link">お問い合わせフォーム</a>からご要望をお知らせいただけましたら、2営業日以内にご連絡いたします。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="Question135">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question135Content" aria-expanded="true"
                                        aria-controls="Question135Content">
                                        請求書の発行方法は？請求書の宛名に大学名・企業名を入れることは可能か？
                                    </a>
                                </div>

                                <div id="Question135Content" class="collapse" aria-labelledby="Question135" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            大学名や研究室名、また明細も記載されたご請求書類を、すべての有料プランをご購入いただいたお客様に対して発行しています。日本語、英語の他、各国語でのご請求書も発行可能です。特定のフォーマットのご請求書類をご所望の場合は<a href="mailto:support&#64;trinka&#46;ai">メールにてお知らせください</a>。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="Question134">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question134Content" aria-expanded="true"
                                        aria-controls="Question134Content">
                                        ビジネス用にTrinkaをカスタマイズするにはどうすればよいか？ 
                                    </a>
                                </div>

                                <div id="Question134Content" class="collapse" aria-labelledby="Question134" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaの法人向けソリューションでは、さまざまなカスタマイズや統合オプションを提供しています。</p>
                                        <p><a (click)="navigationService.goToEnterpriseForm()" class="text-link">お問い合わせフォーム</a>に詳細をご記入の上、ご送信ください。</p>
                                        
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="Question15">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question15Content" aria-expanded="true"
                                        aria-controls="Question15Content">
                                        Trinkaの法人向け料金プランは？
                                    </a>
                                </div>

                                <div id="Question15Content" class="collapse" aria-labelledby="Question15" data-parent="#faq">
                                    <div class="card-body">
                                        <p>組織や機関のニーズに合わせた料金プランをご提案いたします。</p>
                                        <p>具体的なご要望がございましたら、<a href="mailto:connect&#64;trinka&#46;ai" class="text-link">connect@trinka.ai</a> までメールにてお問い合わせください。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="Question16">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question16Content" aria-expanded="true"
                                        aria-controls="Question16Content">
                                        博士課程の学生には学割はあるか？ 
                                    </a>
                                </div>

                                <div id="Question16Content" class="collapse" aria-labelledby="Question16" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。Trinkaでは博士課程の皆様に割引をご提供しています。</p>
                                        <p>ご利用いただける学生割引についてのお問い合わせは、<a href="mailto:support&#64;trinka&#46;ai" class="text-link">support@trinka.ai</a>までメールにてご連絡ください。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">プレミアムプランのご購入で充実の英文ライティング機能を</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">プランを購入する</a>
                </div>
            </div>
        </div>  
    </div>
</div>

